import {createApp} from 'vue'
import DirectMessageNavigation from './DirectMessageNavigation'

const el = '.kb-component--direct-message-navigation'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((DirectMessageNavigationDOM) => {
            const externalData = JSON.parse(DirectMessageNavigationDOM.dataset.external)

            const props = {
                guid: DirectMessageNavigationDOM.dataset.guid,
                userData: externalData?.userData,
                chatId: externalData?.chatId,
                messagesPerLoad: externalData?.messagesPerLoad
            }
            const component = createApp(DirectMessageNavigation, props).use(Store)
            component.mount(DirectMessageNavigationDOM)
        })
    }
}